export class NameInputEvents
{
    static LOCK_BY_INPUTING: string =  'NameInputEvents.LOCK_BY_INPUTING';
    static UNLOCK_BY_INPUTING: string =  'NameInputEvents.UNLOCK_BY_INPUTING';
}
